module.exports = __webpack_public_path__ + "static/media/car.1081de60.svg";